export function rotuloNatureza(natureza) {
  return natureza?.nome || "";
}
